import {useNavigate, useParams} from "react-router-dom";
import {getJobDetails, getJobNotes, updateJobAdmin} from "../service/JobService";
import {useEffect, useState} from "react";
import {Button, Col, Container, Form, Row, Tab, Nav, Badge, Alert, Spinner, Toast, ToastContainer} from "react-bootstrap";
import {convertDescriptionPrefix, covertJobTitle} from "../service/jobutil";
import {getFieldWorkers} from "../service/UserService";
import JobImageUpload from "./JobImageUpload";
import JobImageGallary from "./JobImageGallary";
import JobNotes from "./JobNotes";
import JobChecklist from "./checklist/JobChecklist";
import JobSourceBadge from "./JobSourceBadge";


export default function UpdateJob({jobId = null, onSaved} = {}) {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false)
    const [jobDetails, setJobDetails] = useState({})
    const [responseMessage, setResponseMessage] = useState('')
    const [responseType, setResponseType] = useState('') // 'success' or 'danger'
    const [fieldWorkerMap, setFieldWorkerMap] = useState({})
    const [images, setImages] = useState([])
    const [jobNotes, setJobNotes] = useState([])
    const [activeTab, setActiveTab] = useState('details')
    const [showToast, setShowToast] = useState(false)
    const [toastMessage, setToastMessage] = useState('')

    const routeParams = useParams();
    const cos_job_id = jobId || routeParams.cos_job_id;

    function refreshFieldWorkers() {
        getFieldWorkers().then(response => {
                if (response.status === 200) {
                    response.json().then(result => {
                        let tmpFieldWorkerMap = {};
                        result.map(obj => {
                            tmpFieldWorkerMap[obj.id] = obj.name
                        })
                        setFieldWorkerMap(tmpFieldWorkerMap)
                    })
                } else {
                    response.text().then(result => console.log(result))
                }
            }
        ).catch(error => console.log('error', error));
    }

    function refreshJob() {
        getJobDetails(cos_job_id).then(response => {
            if (response.status === 200) {
                response.json().then(result => {
                    setJobDetails(result)
                })
            } else {
                response.text().then(result => {
                        setResponseMessage(result)
                    }
                )

            }
        }).catch(error => console.log('error', error));
        
        // Fetch job notes to get count
        getJobNotes(cos_job_id).then(response => {
            if (response.status === 200) {
                response.json().then(result => {
                    setJobNotes(result || []);
                });
            } else {
                console.log("Error fetching job notes");
            }
        }).catch(error => console.log('error', error));
    }

    useEffect(() => {
        refreshJob();
        refreshFieldWorkers();
    }, [cos_job_id]);


    function handleSubmitUpdate(e) {
        e.preventDefault();
        setIsLoading(true);
        setResponseMessage('');
        setResponseType('');
        
        updateJobAdmin(jobDetails).then(response => {
            if (response.status === 200) {
                response.json().then(result => {
                    if (onSaved) {
                        onSaved(result);
                        return;
                    }

                    setToastMessage('Job Updated successfully');
                    setShowToast(true);
                    // Wait a moment before navigating back so the user can see the success message
                    setTimeout(() => {
                        navigate(-1);
                    }, 1500);
                });
            } else {
                response.text().then(result => {
                    setResponseMessage(result);
                    setResponseType('danger');
                    refreshJob();
                });
            }
        }).catch(error => {
            console.log('error', error);
            setResponseMessage('An error occurred while updating the job. Please try again.');
            setResponseType('danger');
        }).finally(() => setIsLoading(false));
    }

    return (

        <Container fluid={"md"}>
            {jobDetails.cos_job_id ? <>
                <h3>{covertJobTitle(jobDetails)}</h3>
                <hr/>
                <Tab.Container id="job-tabs" activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
                    <Nav variant="tabs" className="mb-3">
                        <Nav.Item>
                            <Nav.Link eventKey="details">Job Details</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="images">
                                Images <Badge bg="secondary">{images.length}</Badge>
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="notes">
                                Notes <Badge bg="secondary">{jobNotes.length}</Badge>
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="checklist">
                                Checklist <Badge bg="secondary">{jobDetails.checklists ? jobDetails.checklists.length : 0}</Badge>
                            </Nav.Link>
                        </Nav.Item>
                    </Nav>
                    
                    <Tab.Content>
                        <Tab.Pane eventKey="details">
                            <Form onSubmit={handleSubmitUpdate}>
                                <Row style={{textAlign: "left"}}>
                        <Col>
                            <Row className="mt-1">
                                <Col sm={3}>ID:</Col>
                                <Col sm={9}>{jobDetails.cos_job_id}</Col>
                            </Row>
                            <Row className="mt-1">
                                <Col sm={3}>Source:</Col>
                                <Col sm={9}><JobSourceBadge job={jobDetails} showLabel/></Col>
                            </Row>
                            <Row className="mt-1">
                                <Col sm={3}>Address:</Col>
                                <Col sm={9}>{jobDetails.full_address}</Col>
                            </Row>
                            <Row className="mt-1">
                                <Col sm={3}>Customer Name:</Col>
                                <Col sm={9}>{jobDetails.cos_customer_name}</Col>
                            </Row>
                            <Row className="mt-1">
                                <Col sm={3}>Agent Name:</Col>
                                <Col sm={9}>{jobDetails.agent_name}</Col>
                            </Row>
                            <Row className="mt-1">
                                <Col sm={3}>Date:</Col>
                                <Col sm={9}>{jobDetails.date}</Col>
                            </Row>
                            <Row className="mt-1">
                                <Col sm={3}>Field Worker:</Col>
                                <Col sm={9}>
                                    <Form.Select
                                        value={jobDetails.cos_job_worker ? jobDetails.cos_job_worker : ''}
                                        onChange={(e) => setJobDetails({
                                            ...jobDetails,
                                            cos_job_worker: e.target.value
                                        })}>
                                        {Object.keys(fieldWorkerMap).map((key, index) =>
                                            <option key={index} value={key}> {fieldWorkerMap[key]} </option>
                                        )}

                                    </Form.Select>
                                </Col>
                            </Row>
                            <Row className="mt-1">
                                <Col sm={3}>Consumable:</Col>
                                <Col sm={9}>{convertDescriptionPrefix(jobDetails)}</Col>
                            </Row>
                            <Row className="mt-1">
                                <Col sm={3}>Description:</Col>
                                <Col sm={9}><Form.Control
                                    as="textarea"
                                    value={jobDetails.description}
                                    placeholder="Leave a comment here"
                                    onChange={(e) => setJobDetails({
                                        ...jobDetails,
                                        description: e.target.value
                                    })}
                                    style={{height: '256px'}}
                                /></Col>
                            </Row>

                        </Col>
                        <Col>
                            <Row className="mt-1"><Col sm={3}>Status:</Col>
                                <Col sm={9}>
                                    <Form.Select
                                        value={jobDetails.status}
                                        onChange={(e) => setJobDetails({
                                            ...jobDetails,
                                            status: e.target.value
                                        })}>
                                        <option value="Scheduled">Scheduled</option>
                                        <option value="InProgress">InProgress</option>
                                        <option value="ReadyForBilling">ReadyForBilling</option>
                                        <option value="Cancelled">Cancelled</option>
                                    </Form.Select></Col></Row>

                            <Row className="mt-1">
                                <Col sm={3}>Phone:</Col>
                                <Col sm={9}><Form.Control
                                    type="text"
                                    value={jobDetails.phone}
                                    placeholder="Customer Phone Number..."
                                    onChange={(e) => setJobDetails({
                                        ...jobDetails,
                                        phone: e.target.value
                                    })}/></Col>
                            </Row>
                            <Row className="mt-1">
                                <Col sm={3}>Email:</Col>
                                <Col sm={9}><Form.Control
                                    type="text"
                                    value={jobDetails.email}
                                    placeholder="Customer Phone Number..."
                                    onChange={(e) => setJobDetails({
                                        ...jobDetails,
                                        email: e.target.value
                                    })}/></Col>
                            </Row>
                            <Row className="mt-1">
                                <Col sm={3}>Consumable Type:</Col>
                                <Col sm={9}><Form.Select
                                    value={jobDetails.consumable_type}
                                    onChange={(e) => setJobDetails({
                                        ...jobDetails,
                                        consumable_type: e.target.value
                                    })}>
                                    <option value="SERVICE_CONSUMABLE">SERVICE_CONSUMABLE</option>
                                    <option value="NO_CONSUMABLE">NO_CONSUMABLE</option>
                                    <option value="BRING_YOUR_OWN_CONSUMABLE">BRING_YOUR_OWN_CONSUMABLE</option>

                                </Form.Select></Col>
                            </Row>
                            <Row className="mt-1">
                                <Col sm={3}>Check Out:</Col>
                                <Col sm={9}><Form.Select
                                    value={jobDetails.check_out}
                                    onChange={(e) => setJobDetails({
                                        ...jobDetails,
                                        check_out: e.target.value
                                    })}>
                                    <option value="8:00">8:00</option>
                                    <option value="9:00">9:00</option>
                                    <option value="10:00">10:00</option>
                                    <option value="11:00">11:00</option>
                                    <option value="12:00">12:00</option>
                                    <option value="13:00">13:00</option>
                                    <option value="14:00">14:00</option>
                                    <option value="15:00">15:00</option>
                                    <option value="16:00">16:00</option>
                                    <option value="17:00">17:00</option>
                                    <option value="18:00">18:00</option>
                                    <option value="19:00">19:00</option>
                                    <option value="20:00">20:00</option>
                                    <option value="21:00">21:00</option>
                                    <option value="22:00">22:00</option>
                                </Form.Select></Col>
                            </Row>
                            <Row className="mt-1">
                                <Col sm={3}>Check In:</Col>
                                <Col sm={9}><Form.Select
                                    value={jobDetails.check_in}
                                    onChange={(e) => setJobDetails({
                                        ...jobDetails,
                                        check_in: e.target.value
                                    })}>
                                    <option value={null}></option>
                                    <option value="8:00">8:00</option>
                                    <option value="9:00">9:00</option>
                                    <option value="10:00">10:00</option>
                                    <option value="11:00">11:00</option>
                                    <option value="12:00">12:00</option>
                                    <option value="13:00">13:00</option>
                                    <option value="14:00">14:00</option>
                                    <option value="15:00">15:00</option>
                                    <option value="16:00">16:00</option>
                                    <option value="17:00">17:00</option>
                                    <option value="18:00">18:00</option>
                                    <option value="19:00">19:00</option>
                                    <option value="20:00">20:00</option>
                                    <option value="21:00">21:00</option>
                                    <option value="22:00">22:00</option>
                                </Form.Select></Col>
                            </Row>
                            <Row className="mt-1">
                                <Col sm={3}>Bedroom:</Col>
                                <Col sm={9}><Form.Control
                                    type="number"
                                    value={jobDetails.bedroom}
                                    placeholder="Customer Phone Number..."
                                    onChange={(e) => setJobDetails({
                                        ...jobDetails,
                                        bedroom: e.target.value
                                    })}/></Col>
                            </Row>
                            <Row className="mt-1">
                                <Col sm={3}>Bathroom:</Col>
                                <Col sm={9}><Form.Control
                                    type="number"
                                    value={jobDetails.bathroom}
                                    placeholder="Customer Phone Number..."
                                    onChange={(e) => setJobDetails({
                                        ...jobDetails,
                                        bathroom: e.target.value
                                    })}/></Col>
                            </Row>
                            <Row className="mt-1">
                                <Col sm={3}>Sofabed:</Col>
                                <Col sm={9}><Form.Control
                                    type="number"
                                    value={jobDetails.sofabed}
                                    placeholder="Customer Phone Number..."
                                    onChange={(e) => setJobDetails({
                                        ...jobDetails,
                                        sofabed: e.target.value
                                    })}/></Col>
                            </Row>
                            <Row className="mt-1">
                                <Col sm={3}>King:</Col>
                                <Col sm={9}><Form.Control
                                    type="number"
                                    value={jobDetails.king}
                                    placeholder="Customer Phone Number..."
                                    onChange={(e) => setJobDetails({
                                        ...jobDetails,
                                        king: e.target.value
                                    })}/></Col>
                            </Row>
                            <Row className="mt-1">
                                <Col sm={3}>Queen:</Col>
                                <Col sm={9}><Form.Control
                                    type="number"
                                    value={jobDetails.queen}
                                    placeholder="Customer Phone Number..."
                                    onChange={(e) => setJobDetails({
                                        ...jobDetails,
                                        queen: e.target.value
                                    })}/></Col>
                            </Row>
                            <Row className="mt-1">
                                <Col sm={3}>Single:</Col>
                                <Col sm={9}><Form.Control
                                    type="number"
                                    value={jobDetails.single}
                                    placeholder="Customer Phone Number..."
                                    onChange={(e) => setJobDetails({
                                        ...jobDetails,
                                        single: e.target.value
                                    })}/></Col>
                            </Row>


                        </Col>
                                    <Row className="mt-3">
                                        <Col sm={3}>
                                            <Button 
                                                type="submit"
                                                disabled={isLoading}
                                                variant="primary"
                                            >
                                                {isLoading ? (
                                                    <>
                                                        <Spinner
                                                            as="span"
                                                            animation="border"
                                                            size="sm"
                                                            role="status"
                                                            aria-hidden="true"
                                                            className="me-2"
                                                        />
                                                        Saving...
                                                    </>
                                                ) : 'Save'}
                                            </Button>
                                        </Col>
                                        <Col sm={5}>
                                            {responseMessage && responseType && (
                                                <Alert variant={responseType} className="p-2 mb-0">
                                                    {responseMessage}
                                                </Alert>
                                            )}
                                        </Col>
                                        <Col sm={3}>
                                            <Button
                                                disabled={isLoading}
                                                onClick={() => {
                                                    setResponseMessage('');
                                                    setResponseType('');
                                                    refreshJob();
                                                }}
                                                variant="secondary"
                                            >
                                                Reset
                                            </Button>
                                        </Col>
                                    </Row>
                                </Row>
                            </Form>
                        </Tab.Pane>
                        
                        <Tab.Pane eventKey="images">
                            <Row>
                                <div><JobImageUpload job={jobDetails}
                                                    images={images}
                                                    setImages={setImages}/></div>
                                <div><JobImageGallary job={jobDetails}
                                                    isReadOnly={false}
                                                    images={images}
                                                    setImages={setImages}/></div>
                            </Row>
                        </Tab.Pane>
                        
                        <Tab.Pane eventKey="notes">
                            <Row>
                                <Col>
                                    <JobNotes jobId={cos_job_id} />
                                </Col>
                            </Row>
                        </Tab.Pane>

                        <Tab.Pane eventKey="checklist" mountOnEnter>
                            <Row>
                                <Col>
                                    <JobChecklist jobDetails={jobDetails} onJobUpdated={(result) => setJobDetails(result)} />
                                </Col>
                            </Row>
                        </Tab.Pane>
                    </Tab.Content>
                </Tab.Container>
            </> : 'No Job Found'}
            <ToastContainer 
                position="top-end" 
                className="p-3" 
                style={{ zIndex: 1 }}
            >
                <Toast 
                    onClose={() => setShowToast(false)} 
                    show={showToast} 
                    delay={3000} 
                    autohide 
                    bg="success"
                >
                    <Toast.Header closeButton={false}>
                        <strong className="me-auto">Success</strong>
                    </Toast.Header>
                    <Toast.Body className="text-white">{toastMessage}</Toast.Body>
                </Toast>
            </ToastContainer>
        </Container>
    );
}
